<template>
  <p :class="message.class || 'error'"
     v-html="$t(message.content)"
  />
</template>

<script>
import * as alertMutations from '../../store/modules/alert/mutation-types'

export default {
  name: 'AlertMessage',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.$store.commit(`alert/${alertMutations.SET_ALERT_VIEWED}`, this.message)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/AlertMessage.vue